module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image8-f8fcb78d1f73b497ac0daa87467dbfb4.png";